import { Component, inject } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { IonicModule } from '@ionic/angular';

import { ultraAnimations } from 'app/shared/animations';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	animations: ultraAnimations,
	imports: [IonicModule],
})
export class AppComponent {
	isNative = Capacitor.isNativePlatform();
}
